module.exports = __webpack_public_path__ + "img/image12.a5611471.png";